import { formatSaleEndDate, formatSaleEndDateInTimeZone } from '../utils';
import { useFormatDate } from './useFormatDate';
export const CHANGE_SALE_DISCLAIMER_SPEC = 'changeSaleDisclaimer';
export const useFormatSaleDisclaimerEndDate = _ref => {
  let {
    locale,
    geo,
    isChangeSaleDisclaimerEnabled
  } = _ref;
  const formatDate = useFormatDate({
    locale
  });
  return endDate => {
    const saleEndDate = new Date(endDate).getTime();
    return isChangeSaleDisclaimerEnabled ? formatSaleEndDateInTimeZone({
      saleEndDate,
      geo,
      locale
    }) : formatSaleEndDate({
      saleEndDate,
      geo,
      formatter: formatDate
    });
  };
};
//# sourceMappingURL=useFormatSaleDisclaimerEndDate.js.map